module.exports = __webpack_public_path__ + "img/profile.3fb145ab.jpg";